exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-31a54256] .el-tabs__header{margin-bottom:0}.el-dropdown-link[data-v-31a54256]{cursor:pointer;color:#90c328}[data-v-31a54256] #list_table .el-button+.el-button{margin-left:0}", ""]);

// exports
